import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    state: {
        types: []
    },

    mutations: {
        updateVacationTypes(state, types) {
            state.types = types;
        },
        setTypes(state, types) {
            types.sort((a, b) => a.sort - b.sort);
            state.types = types;
        },
        addType(state, newType) {
            state.types = [newType, ...state.types];
        },
        editType(state, typeData) {
            state.types = state.types.map(type => {
                if (type.id === typeData.id) {
                    return typeData;
                }
                return type;
            });
        },
        removeType(state, typeId) {
            state.types = state.types.filter(type => type.id !== typeId);
        }
    },

    actions: {
        async loadTypes(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/vacation-types/index`, token)
            );
            const json = await res.json();
            ctx.commit("setTypes", json);

            return json;
        },

        async resortTypes(ctx, params) {
            const order = params.types.map((id, i) => ({
                id,
                sort: i
            }));
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/vacation-types/update-sort`, token),
                {
                    method: "PUT",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(order)
                }
            );
            const json = await res.json();

            return json;
        },

        async addType(ctx, params) {
            const token = ctx.rootState.authToken;
            const formData = serialize({
                name: params.name,
                description: params.description,
                color: params.color,
                timesheet_code: params.code
            });
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/vacation-types/create`, token),
                { method: "POST", body: formData }
            );

            const json = await res.json();
            if (json.success) {
                ctx.commit("addType", json.model);
                ctx.dispatch("resortTypes", {
                    types: ctx.state.types.map(t => t.id)
                });
            }
            return json;
        },

        async editType(ctx, params) {
            const token = ctx.rootState.authToken;
            const formData = serialize({
                name: params.name,
                description: params.description,
                color: params.color,
                timesheet_code: params.code
            });
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/vacation-types/update&id=${params.id}`, token),
                { method: "PUT", body: formData }
            );
            const json = await res.json();
            if (json.success) {
                ctx.commit("editType", json.model);
            }
            return json;
        },

        async removeType(ctx, params) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/vacation-types/delete&id=${params.id}`, token),
                { method: "DELETE" }
            );
            await res.json();
            ctx.commit("removeType", params.id);
        }
    }
};
